<script setup lang="ts">
const props = defineProps<{ password: string }>()
const rules = computed(() => passwordRules(props.password))
</script>

<template>
  <ul class="rules" aria-label="Password requirements">
    <li v-for="r in rules" :key="r.id" class="rules__item" :class="{ 'is-ok': r.ok }">
      <AppIcon :name="r.ok ? 'check-circle' : 'x'" :size="16" />
      <span class="rules__sr">{{ r.ok ? 'Met:' : 'Not met:' }}</span>
      {{ r.label }}
    </li>
  </ul>
</template>

<style scoped>
.rules {
  display: grid;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.rules__item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
  color: var(--gray-600);
}

.rules__item.is-ok {
  color: var(--success-700);
}

.rules__sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
